import React from 'react';
import PropTypes from 'prop-types';
import { formatText, FormattedText } from 'core/i18n';
import IconClose from 'assets/icons/icon-close.svg';
import 'react-virtualized/styles.css';

export const DocumentsModalScrollInfo = ({
    handleClickCloseButton,
    handleClickCancelButton,
    handleClickContinueButton,
}) => {
    return (
        <div className={'documents__modal__scroll-info__box-outside'}>
            <div className={'documents__modal__scroll-info__box-inside'}>
                <div className="documents__modal__scroll-info__container">
                    <div className="documents__modal__scroll-info-heading">
                        <div className="documents__modal__scroll-info-heading__close-icon">
                            <button onClick={handleClickCloseButton}>
                                <img src={IconClose} alt="close" />
                            </button>
                        </div>
                        <h4>{formatText('modalScroll-title')}</h4>
                    </div>
                    <div className="documents__modal__scroll-info-body">
                        <div className="documents__modal__scroll-info-body-gif">
                            <span className="icons--mandatory-scroll-icon" />
                        </div>
                        <FormattedText value="modalScroll-text1" />
                        <FormattedText value="modalScroll-text2" />
                    </div>
                    <div className="documents__modal__scroll-info-buttons">
                        <span>
                            <button onClick={handleClickCancelButton}>
                                <p aria-label="close-btn">{formatText('button-exit')}</p>
                            </button>
                        </span>
                        <button
                            className="form__button form__button-secondary"
                            onClick={handleClickContinueButton}
                            aria-label="confirm-btn"
                        >
                            {formatText('button-understood')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

DocumentsModalScrollInfo.propTypes = {
    handleClickCloseButton: PropTypes.func,
    handleClickCancelButton: PropTypes.func,
    handleClickContinueButton: PropTypes.func,
};
